// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.layout[data-v-ba0824dc]{\r\n  position: relative;\n}\n.background[data-v-ba0824dc]{\r\n  background: #f6f6f6;\r\n  min-height: calc(100vh - 70px);\r\n  padding: 0;\n}\n@media screen and (max-width:650px){\n.background[data-v-ba0824dc]{\r\n    max-height: auto;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
